import React from 'react';
import { Bitcoin } from 'lucide-react';

export const defaultCryptoQuestions = [
  {
    id: 'logo',
    placeholder: 'logo',
    title: 'uploadLogo',
    type: 'avatar',
    image: <Bitcoin size={60} className='file-icon' />,
    mandatory: false,
  },
  {
    id: 'name',
    type: 'text',
    title: 'name',
    placeholder: 'name',
    mandatory: true,
  },
  {
    id: 'description',
    type: 'text',
    title: 'description',
    placeholder: 'description',
    mandatory: true,
  },
  {
    id: 'address',
    type: 'text',
    title: 'address',
    placeholder: 'address',
    mandatory: false,
  },
  {
    id: 'ticker',
    type: 'text',
    title: 'ticker',
    placeholder: 'ticker',
    mandatory: false,
  },
  {
    id: 'blockchain',
    type: 'select',
    title: 'blockchain',
    placeholder: 'blockchain',
    mandatory: false,
    answers: ['erc20', 'bitcoin_network', 'Other'],
  },
  {
    id: 'developmentTeam',
    type: 'text',
    title: 'developmentTeam',
    placeholder: 'developmentTeam',
    mandatory: false,
  },
  {
    id: 'marketCap',
    type: 'number',
    title: 'marketCap',
    placeholder: 'marketCap',
    mandatory: false,
  },
  {
    id: 'circulatingSupply',
    type: 'number',
    title: 'circulatingSupply',
    placeholder: 'circulatingSupply',
    mandatory: false,
  },
  {
    id: 'explorerLink',
    type: 'text',
    title: 'explorerLink',
    placeholder: 'explorerLink',
    mandatory: false,
  },
];
